import React from "react";
import styled from "styled-components";

const Container = styled('footer')`
  margin-top: 6rem;
  display: flex;
  border-top: 1px solid ${props => props.theme.palette.grey[200]};
  padding: 2rem;
  font-size: 1.4rem;

  a {

    color: ${props => props.theme.colors.primary};
    text-decoration: underline;
  }
  div {
    
  }
`;

const AuthorBox = styled('div')`
  
`
const SourceBox = styled('div')`
  margin-left: auto;
`;

const Footer = () => {
  return (
    <Container>
      <AuthorBox>
        Author:&nbsp;
        <a href="https://miedziak.io" rel="noopener noreferrer" target="_blank">www.miedziak.io</a>
      </AuthorBox>
      <SourceBox>
        Data from
        <a href="https://github.com/CSSEGISandData/COVID-19" rel="noopener noreferrer" target="_blank"> Johns Hopkins University Center</a>
      </SourceBox>
    </Container>
  );
};


export default Footer;
